import React from 'react'
import { FormCheckbox } from '@myxplor/forms'

const ExtensionReasons = ({ onChange, values }) => {
  return (
    <fieldset>
      <legend>3. Extension Reasons</legend>
      Choose the reasons for extension that {values.name} is facing which apply to this
      determination. You are able to select more than one option.
      <FormCheckbox
        label={
          'The child is on long term protection order.'
        }
        name={'extension_reasons.LONGPO'}
        value={values.extension_reasons.LONGPO}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        label={'The child is in formal foster care/kinship care.'}
        name={'extension_reasons.FOSKIN'}
        value={values.extension_reasons.FOSKIN}
        onChange={onChange}
        compact
      />
    </fieldset>
  )
}

export default ExtensionReasons



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/extension-reasons.js